import * as Yup from 'yup';
import { maxValidationString, minValidationNumber, minValidationString, requiredField } from '../../helperFuncs';

export const infoByAFMValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const infoByNameValidationSchema =
  Yup.object({
    fathersFirstName:
      Yup.string()
        .required(requiredField),
    surnameA:
      Yup.string()
        .required(requiredField),
    nameA:
      Yup.string()
        .required(requiredField),
  });

export const infoByADTValidationSchema =
  Yup.object({
    adt:
      Yup.string()
        .required(requiredField),
    kind:
      Yup.string()
        .required(requiredField),
  });

export const confirmBankValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    iban:
      Yup.string()
        .required(requiredField)
        .min(27, 'Λανθασμένο πλήθος ψηφίων IBAN')
        .max(27, 'Λανθασμένο πλήθος ψηφίων IBAN'),
  });

export const infoByAMKAValidationSchema =
  Yup.object({
    amka:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(11, minValidationString(11))
        .max(11, maxValidationString(11)),
  });

export const amkaByInfoValidationSchema =
  Yup.object({
    surname:
      Yup.string()
        .required(requiredField),
    firstName:
      Yup.string()
        .required(requiredField),
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const retrieveForeasInfoByAFMValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const paravolaInfoValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    foreasId:
      Yup.number()
        .required(requiredField)
        .min(0, minValidationNumber(0)),
    categoryId:
      Yup.number()
        .required(requiredField)
        .min(0, minValidationNumber(0)),
    dateFrom: Yup.string()
      .nullable()
      .required(requiredField),
    dateTo: Yup.string()
      .nullable()
      .required(requiredField)
      .test(
        'dateTo', 'Παρακαλώ προσθέστε έγκυρη μορφή ημερομηνίας',
        function (value) {
          const { dateFrom } = this.parent;
          return !dateFrom || new Date(value as string) >= new Date(dateFrom);
        }
      ),
  });

export const fetchAllCategoriesValidationSchema =
  Yup.object({
    foreasCode:
      Yup.number()
        .required(requiredField)
        .min(0, minValidationNumber(0)),
  });

export const fetchAllTypesValidationSchema =
  Yup.object({
    categoryCode:
      Yup.number()
        .required(requiredField)
        .min(0, minValidationNumber(0)),
  });

export const userDetailsValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const paravoloTypeValidationSchema =
  Yup.object({
    typeId:
      Yup.number()
        .required(requiredField)
        .min(0, minValidationNumber(0)),
  });

export const paravoloStatuseValidationSchema =
  Yup.object({
    paravoloPaymentCode:
      Yup.string()
        .required(requiredField),
  });

export const createParavoloShortValidationSchema =
  Yup.object({
    typeCode:
      Yup.number()
        .required(requiredField),
    paravoloAmount:
      Yup.number()
        .required(requiredField),
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    firstName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    lastName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    fatherName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
  });

export const createParavoloValidationSchema =
  Yup.object({
    typeCode:
      Yup.number()
        .required(requiredField),
    paravoloAmount:
      Yup.number()
        .required(requiredField),
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    firstName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    lastName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    fatherName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    motherName:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    iban:
      Yup.string()
        .required(requiredField)
        .max(50, maxValidationString(50)),
    sendEmail:
      Yup.number()
        .required(requiredField),
    emailAddress:
      Yup.string()
        .required(requiredField)
        .email('Μη αποδεκτή μορφή Email')
        .max(50, maxValidationString(50)),
    mobilePhone:
      Yup.string()
        .required(requiredField)
        .max(30, maxValidationString(30)),
    birthDate:
      Yup.string()
        .required(requiredField),
    additionalInfo:
      Yup.string()
        .max(120, maxValidationString(120)),
  });

export const gemiAFMValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const gemiBranchValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    arGemi:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(5, minValidationString(5))
        .max(12, maxValidationString(12)),
  });

export const gemiBoardValidationSchema =
  Yup.object({
    arGemi:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(5, minValidationString(5))
        .max(12, maxValidationString(12)),
  });

export const gemiBoardV3ValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    arGemi:
      Yup.string()
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(5, minValidationString(5))
        .max(12, maxValidationString(12)),
  });

export const gemiBasicInfoValidationSchema =
  Yup.object({
    arGemi:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(5, minValidationString(5))
        .max(12, maxValidationString(12)),
  });

export const gemiBasicInfoV3ValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    arGemi:
      Yup.string()
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(5, minValidationString(5))
        .max(12, maxValidationString(12)),
  });

export const afeIssueValidationSchema =
  Yup.object({
    afeAfm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    afeIssuedByAfm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    afeEmployeeAfm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    afeIssuedByDescr:
      Yup.string()
        .required(requiredField)
        .max(200, maxValidationString(200)),
    afeIssuedByDescr2:
      Yup.string()
        .matches(/^[A-ZΑ-Ω0-9 ]*$/, 'Συπληρώστε μόνο κεφαλαία'),
    afeIssuedByDescr3:
      Yup.string(),
    afeText:
      Yup.string()
        .required(requiredField)
        .max(250, maxValidationString(250)),
    afeForeas:
      Yup.string()
        .required(requiredField)
        .max(250, maxValidationString(250)),
    afeReason:
      Yup.number()
        .required(requiredField),
    afePdfRequested:
      Yup.string()
        .required(requiredField),
  });
export const afeValidationSchema =
  Yup.object({
    rvAfeType:
      Yup.number()
        .required(requiredField),
    // rvAfeDoy: 
    //   Yup.string()
    //     .required(requiredField)
    //     .min(4, minValidationString(4))
    //     .max(4, maxValidationString(4)),
    rvAfeAa:
      Yup.number()
        .required(requiredField),
    rvAfeYear:
      Yup.number()
        .required(requiredField),
    rvAfeAfm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
  });

export const aadeKadValidationSchema =
  Yup.object({
    afm:
      Yup.string()
        .required(requiredField)
        .matches(/^[0-9]+$/, 'Παρακαλούμε συμπληρώστε μόνο αριθμούς')
        .min(9, minValidationString(9))
        .max(9, maxValidationString(9)),
    dateFrom: Yup.string()
      .nullable()
      .required(requiredField),
    dateTo: Yup.string()
      .nullable()
      .required(requiredField)
      .test(
        'dateTo', 'Παρακαλώ προσθέστε έγκυρη μορφή ημερομηνίας',
        function (value) {
          const { dateFrom } = this.parent;
          return !dateFrom || new Date(value as string) >= new Date(dateFrom);
        }
      )
  });